<template>
  <div>
    <section class="content-blocks">
      <div class="row no-gutters">
        <template v-for="(c, index) in content">
          <div v-bind:key="index" v-if="c.value.includes('img')" v-html="c.value" class="col-md-6 block" data-aos="fade-in"></div>
          <div v-bind:key="index" v-else
               v-bind:class="['block col-md-6 d-flex align-items-center', {
                 'bg-dark' : c.name === 'Vintriguing Panel' ,
                 'bg-green' : c.name === 'Excellence Panel',
                 'bg-yellow' : c.name === 'Sustainability Panel'
               }]">
            <div v-html="c.value" class="content" data-aos="fade-up"></div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'ContentBlocks',
    data() {
      return {
        content: [],
      };
    },
    methods: {
      loadContent: function (content) {
        this.content = content;
      }
    }
  }
</script>
